import { render, staticRenderFns } from "./TheNotFoundPage.vue?vue&type=template&id=a6aae092"
import script from "./TheNotFoundPage.vue?vue&type=script&lang=js"
export * from "./TheNotFoundPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports